import {css} from 'lit';
import {tablet} from '../../js/services/const';

export default css`
  ::selection {
    background: var(--brand);
    color: var(--brand-text);
  }
  .externalembedlist__link {
    position: absolute;
    right: 0;
    top: 0;
    font-weight: normal;
  }
  @media (min-width: ${tablet}px) {
    .externalembedlist__link {
      font-size: 1.4rem;
      right: 3rem;
      top: 2.6rem;
    }
  }
  .externalembedlist__link a {
    color: var(--system-hyperlink);
    cursor: pointer;
  }
  .externalembedlist__link a:hover {
    background-color: var(--link-bg-hover);
  }
  .externalembedlist__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--cp-grey-light-7);
  }
  .externalembedlist__item:nth-of-type(even) {
    background-color: var(--body-bg);
  }
  .externalembedlist__text {
    color: var(--chip-doctype-background);
    padding: 2rem;
  }
  .externalembedlist__check {
    padding-right: 2rem;
  }
`;
